"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcColorIndex = void 0;
const calcColorIndex = (index, valuesLength, colorsLength) => {
    let colorIndex = index % colorsLength;
    if (!!index && index === valuesLength - 1 && colorIndex === 0) {
        colorIndex = Math.floor(colorsLength / 2);
    }
    return colorIndex;
};
exports.calcColorIndex = calcColorIndex;
//# sourceMappingURL=calcColorIndex.js.map